import Image from "next/image";
import {
  logo,
  logoDark2,
  PosReceipt,
  proLogo,
  proLogoDark,
} from "../../../public/assets";
import lightMiniLogo from "../../../public/assets/images/pustack_logo.svg";
import barCode from "../../../public/assets/images/bar-code.png";
import successLottie from "../../../public/assets/lottie/success.json";
import React, { FC, useContext } from "react";
import { ThemeContext } from "../../../context";
import dynamic from "next/dynamic";
const Lottie = dynamic(() => import("lottie-react-web"), { ssr: false });
import Confetti from "react-confetti";
import useWindowSize from "react-use/lib/useWindowSize";

interface OrderItemProps {
  label: string;
  value: string;
  large?: boolean;
}
const OrderItem: FC<OrderItemProps> = ({ label, value, large }) => {
  return (
    <div
      className={
        "flex w-full text-sm justify-between items-center " +
        (large ? "text-base" : "")
      }
    >
      <h4 className="font-bold">{label}</h4>
      <h5
        className={
          "font-bold text-black text-opacity-70 " +
          (large ? "text-base" : "text-xs")
        }
      >
        {value}
      </h5>
    </div>
  );
};

export interface PostReceiptData {
  innerFields: Record<string, string | number>;
  outerFields: Record<string, string | number>;
  orderId: string;
}
interface CongratulationScreenProps {
  postReceiptData: any;
  handleClose: () => void;
}
const CongratulationScreen: FC<CongratulationScreenProps> = ({
  postReceiptData,
  handleClose,
}) => {
  const { width, height } = useWindowSize();

  const fields = Object.keys(postReceiptData.innerFields).map((key, index) => ({
    label: key,
    value: postReceiptData.innerFields[key],
  }));
  const mainFields = Object.keys(postReceiptData.outerFields).map(
    (key, index) => ({ label: key, value: postReceiptData.outerFields[key] })
  );

  return (
    <div className="py-10 h-full overflow-y-auto gap-4 md:gap-12 flex flex-col items-center justify-between">
      <Confetti
        width={width}
        height={height}
        recycle={false}
        tweenDuration={4000}
        run={true}
      />
      <div className={"w-[12rem]"}>
        <Image width={100} height={100} src={proLogoDark} alt="Pustack logo" />
      </div>
      <div className="relative bg-[#ececec] py-2 rounded-b-xl w-[80%] max-w-[380px]">
        <Image
          className="-z-10 absolute -top-6 left-0 w-full"
          src={PosReceipt}
          alt={"Receipt"}
        />
        <div className="flex flex-col items-center w-[85%] mx-auto">
          <span className="flex items-center">
            <Image
              className="w-8 h-8 mr-1.5"
              src={lightMiniLogo}
              alt={"Pustack Mini Logo"}
            />
            <span className="font-extrabold">Order Confirmation</span>
          </span>
          <span className="separator broder-0 my-4 border-b-2 border-b-black w-full border-dashed" />
          <div className="w-full flex flex-col gap-2">
            {fields.map((field) => {
              return (
                <OrderItem
                  key={field.label}
                  label={field.label}
                  value={field.value}
                />
              );
            })}
            {/*<OrderItem label="Product" value="PuStack Doubts" />*/}
            {/*<OrderItem label="Date & Time" value="Sep 26th, 10:12 PM" />*/}
            {/*<OrderItem label="Doubts Added" value="20" />*/}
            {/*<OrderItem label="Amount" value="299 INR" />*/}
            {/*<OrderItem label="Status" value="Success" />*/}
          </div>
          <div className={"w-20 h-20"}>
            <Lottie options={{ animationData: successLottie, loop: false }} />
          </div>
          <span className="separator broder-0 my-4 border-b-2 border-b-black w-full border-dashed" />
          {mainFields.map((field) => {
            return (
              <OrderItem
                key={field.label}
                label={field.label}
                value={field.value}
                large
              />
            );
          })}
          <span className="separator broder-0 my-4 border-b-2 border-b-black w-full border-dashed" />
          <Image className="h-12 mb-4 w-full" src={barCode} alt={"Bar Code"} />
          <p className="text-sm font-bold">{postReceiptData.orderId}</p>
          <p className="my-2 text-xs text-opacity-60">
            Thank you for your purchase
          </p>
        </div>
      </div>
      <button
        className="rounded-full p-2 px-6 text-white"
        style={{
          background:
            "linear-gradient(to right, rgb(205, 9, 9), rgb(109, 22, 22))",
          boxShadow: "1px 2px 6px 1px rgb(0, 0, 0)",
        }}
        onClick={handleClose}
      >
        Continue Learning
      </button>
    </div>
  );
};
export default CongratulationScreen;
